import React, { Component } from "react";
import { InputGroup, FormControl, FormGroup, ControlLabel } from "react-bootstrap";
import axios from "axios";
import SaveNavbar from "../components/SaveNavbar";
import LoaderButton from "../components/LoaderButton";
import { EDFormSection, EDFormBox } from "../components/EDDOM";
import parse from "../utils/parse";

export default class IntegrationsShopifyConnect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shop: parse(this).name || '',
      back: parse(this).auto ? '/integrations' : '/integrations/shopify',
      isSaving: false,
    };
  }

  goBack = () => {
    this.props.history.push(this.state.back);
  }

  onChange = event => {
    this.setState({[event.target.id]: event.target.value});
  }

  navbarButtons = () => {
    return (
      <LoaderButton
        id="buttons-dropdown"
        text="Connect"
        loadingText="Connecting..."
        className="green"
        disabled={this.disabled()}
        onClick={this.handleSubmit}
        splitItems={[
          { text: 'Cancel', onClick: this.goBack }
        ]}
      />
    )
  }

  handleSubmit = async e => {
    e.preventDefault();

    this.setState({isSaving: true});

    try {
      var url = (await axios.get('/api/shopifyshops/' + this.state.shop + '/prompt')).data.url;

      var link = document.createElement('a');
      link.href = url;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
    } finally {
      this.setState({isSaving: false});
    }
  }

  disabled() {
    return this.state.isSaving || !this.state.shop || this.state.shop.includes('/');
  }

  render() {
    return (
      <SaveNavbar title="Connect Shopify Shop" user={this.props.user}
        buttons={this.navbarButtons()} onBack={this.goBack} id="new" hideSave={true}>
        <EDFormSection onSubmit={this.handleSubmit}>
          <EDFormBox>
            <FormGroup>
              <ControlLabel>Enter Shop Name:</ControlLabel>
              <InputGroup style={{marginTop: '10px', width: '500px'}}>
                <InputGroup.Addon>{'https://'}</InputGroup.Addon>
                <FormControl type="text" id="shop" value={this.state.shop} onChange={this.onChange} required={true} placeholder="shopname" style={{marginBottom: 0, borderRadius: 'inherit'}}/>
                <InputGroup.Addon>.myshopify.com</InputGroup.Addon>
              </InputGroup>
            </FormGroup>
            <LoaderButton
              id="buttons-dropdown2"
              text="Connect"
              loadingText="Connecting..."
              className="green"
              disabled={this.disabled()}
              onClick={this.handleSubmit}
            />
            <p className="space30">Connecting a shop will create a contact list in your account to receive your customer information. Future updates to customer data will be synchronized automatically.</p>
            <p>All customer data will be added to this list, whether or not a customer has elected to accept marketing. An example segment will be created in your account to filter only those users who accept marketing.</p>
          </EDFormBox>
        </EDFormSection>
      </SaveNavbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/IntegrationsShopifyConnect.js